import { faComputerClassic } from '@fortawesome/pro-regular-svg-icons/faComputerClassic';
import React from 'react';
import { Resource } from '../../../../common/constants/resource';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const RuleResults = ({
  dataLinkId,
  isActive,
  setActive,
}: {
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const notesLink = `${styles.LinkRight} ${styles.NotesLink} ${
    isActive ? styles.Active : ''
  }`;

  const iconClass = `${styles.Icon} ${isActive ? styles.Active : ''}`;

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faComputerClassic}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={notesLink}
      copy={Resource.RULE_RESULTS_TITLE}
      onClick={onClick}
    />
  );
};

export default RuleResults;
